<template>
  <Transition :name="name">
    <slot></slot>
  </Transition>
</template>

<script>
export default {
  props: ["name"]
};
</script>
